import React from 'react';
import Types from 'prop-types';
import { Logo as WiseLogo, LogoType } from '@transferwise/components';
var DEFAULT_LINK = '/';
var Logo = function Logo(_ref) {
  var inverse = _ref.inverse,
    link = _ref.link,
    isTestEnvironment = _ref.isTestEnvironment,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "tw-public-nav__logo".concat(isTestEnvironment ? 'tw-public-nav__logo--with-badge' : '', " ").concat(className)
  }, /*#__PURE__*/React.createElement("a", {
    href: link || DEFAULT_LINK,
    className: "tw-public-nav__logo-link tw-public-nav__logo-link--text"
  }, /*#__PURE__*/React.createElement(WiseLogo, {
    inverse: inverse,
    type: LogoType.WISE
  })), isTestEnvironment && /*#__PURE__*/React.createElement("div", {
    className: "badge m-t-1"
  }, "TEST ENVIRONMENT"));
};
Logo.defaultProps = {
  inverse: false,
  link: '',
  className: '',
  isTestEnvironment: false
};
export default Logo;